import { OrderItem } from "../../../presentations/context/OrderListContext";
import { ItemModel } from "../../../infrastructure/model/ProductItemModel";
import { CreateSaleInfoRequest } from "../../../infrastructure/model/SaleInfoModel";
import {
  SIZE_MAPPING_ENUM,
  SIZE_MAPPING_OPTION,
  SUGAR_ICE_OPTION,
} from "../../constants/AppConst";

export function validateNewPrice(
  request: CreateSaleInfoRequest,
  items: ItemModel[]
): string | null {
  if (
    request.new_price_temp === undefined ||
    request.new_price_temp === null ||
    request.new_price_temp === 0
  ) {
    return null; // Không có giá mới thì không cần validate
  }

  // Lọc các mặt hàng áp dụng
  const applicableItems = items.filter((item) => request.apply_for?.includes(item.id));

  // Duyệt từng mặt hàng
  for (const item of applicableItems) {
    for (const sizeMap of item.size_mapping) {
      // Nếu có lọc theo size
      const isSizeApplicable =
        !request.apply_for_size || request.apply_for_size.includes(sizeMap.size);

      if (isSizeApplicable && request.new_price_temp > sizeMap.price) {
        return `Không được thiết lập giá bán mới lớn hơn giá ban đầu: (${request.new_price_temp?.toLocaleString()}đ) > ${
          item.name
        } size ${SIZE_MAPPING_ENUM[sizeMap.size]} có giá ${sizeMap.price?.toLocaleString()}đ`;
      }
    }
  }

  return null;
}

// Hàm tiện ích tách sugar/ice note và custom note
export const splitNote = (note: string) => {
  if (!note) return { sugarIce: [], custom: "" };
  const parts = note
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  // Lấy danh sách value từ SUGAR_ICE_OPTION
  const sugarIceValues = SUGAR_ICE_OPTION.map((opt) => opt.value);

  const sugarIce = parts.filter((p) => sugarIceValues.includes(p));
  const custom = parts.filter((p) => !sugarIceValues.includes(p)).join(", ");

  return { sugarIce, custom };
};

export const getSizeMappingByItem = (items: ItemModel[], itemId: number) => {
  return items?.find((i) => i.id === itemId)?.size_mapping || [];
};

export const getSizeMappingOptionByItem = (items: ItemModel[], itemId: number) => {
  const itemSizeMapping = getSizeMappingByItem(items, itemId)?.map((s) => s.size) || [];
  return SIZE_MAPPING_OPTION?.filter((op) => itemSizeMapping?.includes(op.value));
};

// Khi change sugar/ice
export const handleSugarIceChange = (
  orderItem: OrderItem,
  values: string[],
  updateOrder: (newItem: OrderItem) => void
) => {
  const { sugarIce, custom } = splitNote(orderItem?.note || "");
  const newNote = [...values, ...(custom ? [custom] : [])].join(", ");
  updateOrder({ ...orderItem, note: newNote });
};

// Khi change custom note
export const handleCustomChange = (
  orderItem: OrderItem,
  value: string,
  updateOrder: (newItem: OrderItem) => void,
  customNoteMap: Map<number, string>,
  setCustomNoteMap: (value: Map<number, string>) => void
) => {
  const newMap = new Map(customNoteMap);
  newMap.set(orderItem.indexAdd!, value); // hoặc orderItem.id nếu có
  setCustomNoteMap(newMap);
  const { sugarIce, custom } = splitNote(orderItem?.note || "");
  const newNote = [...sugarIce, ...(value ? [value] : [])].join(", ");
  updateOrder({ ...orderItem, note: newNote });
};
